/** @jsx jsx */
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import FacetBox from '../DefaultFacet/FacetBox';
import FilterField from '../FilterField';

export default function ExhibitorSearchTermFacet({ value, onChange }) {
  const { i18n } = useLingui();
  return (
    <FacetBox title={<Trans>Search</Trans>}>
      <FilterField
        placeholder={i18n._(t`Type a name…`)}
        value={value}
        onChange={onChange}
        sx={{ marginBottom: 2 }}
      />
    </FacetBox>
  );
}
